import { addDays, isBefore, subYears } from 'date-fns';

export const rules = {
  yearsAgo: ({ value }, years) => {
    return isBefore(
      // Parse the given date and normalize the time.
      new Date(Date.parse(value)).setHours(0, 0, 0, 0),
      // Create the comparison date by using the current date, normalizing the
      // time, subtracting 18 years and adding one day in order to accept all
      // dates before the next day.
      subYears(addDays(new Date().setHours(0, 0, 0, 0), 1), years)
    );
  },
};

export const messages = {
  yearsAgo({ args }) {
    const [years] = args;
    return `Das Datum muss mindestens ${years} Jahr(e) in der Vergangenheit liegen.`;
  },
};
